import { fetchApi } from "./api";

export type SponsorTier = "Platinum" | "Gold" | "Silver" | "Partner";

export type SponsorInput = {
  name: string;
  tier?: SponsorTier;
  logo_url?: string | null;
  website_url?: string | null;
  blurb?: string | null;
  is_active?: boolean;
};

// Public: list sponsors.
export const listSponsors = () =>
  fetchApi<any[]>("people", "listSponsors", {}, { auth: false });

export const createSponsor = (opts: { data: SponsorInput }) =>
  fetchApi<any>("people", "createSponsor", opts.data);

export const updateSponsor = (opts: { data: SponsorInput & { id: string } }) =>
  fetchApi<any>("people", "updateSponsor", opts.data);

export const deleteSponsor = (opts: { data: { id: string } }) =>
  fetchApi<{ ok: true }>("people", "deleteSponsor", opts.data);
